import {
    type MsalGuardConfiguration,
    type MsalInterceptorConfiguration
} from '@azure/msal-angular';
import {
    BrowserCacheLocation,
    InteractionType,
    type IPublicClientApplication,
    LogLevel,
    PublicClientApplication
} from '@azure/msal-browser';
import { environment } from '../../environments/environment';

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: environment.msalConfig.auth.clientId,
            authority: environment.msalConfig.auth.authority,
            redirectUri: environment.msalConfig.auth.redirectUri,
            postLogoutRedirectUri:
                environment.msalConfig.auth.postLogoutRedirectUri
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage
        },
        system: {
            loggerOptions: {
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii) return;
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            break;
                        case LogLevel.Warning:
                            console.warn(message);
                            break;
                        case LogLevel.Info:
                            break;
                        case LogLevel.Verbose:
                            console.debug(message);
                            break;
                    }
                },
                logLevel: LogLevel.Info,
                piiLoggingEnabled: false
            }
        }
    });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: ['user.read']
        },
        loginFailedRoute: '/no-access'
    };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, string[] | null>();

    protectedResourceMap.set(
        `${environment.portalApi.uri}/*`,
        environment.portalApi.scopes
    );

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap,
        strictMatching: true
    };
}
